module.exports = __webpack_public_path__ + "static/img/title-youxitese.987a812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/title-youxitese.png
// module id = A/XT
// module chunks = 1